<template>
  <div
    class="uploader"
    :class="{ 'uploader--dragging': dragging }"
    @dragover.prevent="onDragOver"
    @dragenter.prevent="onDragOver"
    @dragleave.prevent="onDragLeave"
    @drop.prevent="onDrop"
    @click="triggerInput"
  >
    <input
      ref="inputRef"
      class="uploader__input"
      type="file"
      accept="image/png"
      multiple
      @change="onChange"
    />
    <div class="uploader__icon" aria-hidden="true">
      <svg viewBox="0 0 24 24" width="40" height="40" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
        <polyline points="17 8 12 3 7 8" />
        <line x1="12" y1="3" x2="12" y2="15" />
      </svg>
    </div>
    <div class="uploader__title">点击或拖拽 PNG 文件到此处</div>
    <div class="uploader__hint">支持多选 · 单个文件最大 {{ maxSizeMB }} MB · 仅支持 .png 格式</div>
  </div>
</template>

<script>
import { MAX_PNG_BYTES } from '../constants.js';

export default {
  name: 'PngUploader',
  props: {
    maxSizeMB: { type: Number, default: 50 },
  },
  emits: ['files-selected'],
  data() {
    return {
      dragging: false,
      dragDepth: 0,
    };
  },
  methods: {
    triggerInput() {
      this.$refs.inputRef.click();
    },
    onChange(e) {
      const files = Array.from(e.target.files || []);
      this.handleFiles(files);
      // Reset input so re-selecting the same file fires change again.
      e.target.value = '';
    },
    onDragOver() {
      this.dragDepth += 1;
      this.dragging = true;
    },
    onDragLeave() {
      this.dragDepth = Math.max(0, this.dragDepth - 1);
      if (this.dragDepth === 0) this.dragging = false;
    },
    onDrop(e) {
      this.dragDepth = 0;
      this.dragging = false;
      const files = Array.from(e.dataTransfer?.files || []);
      this.handleFiles(files);
    },
    handleFiles(files) {
      const accepted = [];
      const rejected = [];
      for (const f of files) {
        if (f.type !== 'image/png' && !/\.png$/i.test(f.name)) {
          rejected.push({ name: f.name, reason: '不是 PNG 格式' });
          continue;
        }
        if (f.size > MAX_PNG_BYTES) {
          rejected.push({ name: f.name, reason: `超过 ${this.maxSizeMB} MB 限制` });
          continue;
        }
        accepted.push(f);
      }
      this.$emit('files-selected', { accepted, rejected });
    },
  },
};
</script>

<style lang="less" scoped>
.uploader {
  position: relative;
  border: 2px dashed var(--border);
  border-radius: 10px;
  padding: 36px 20px;
  text-align: center;
  background: var(--bg-elev-2);
  cursor: pointer;
  transition: border-color 0.15s ease, background-color 0.15s ease, transform 0.05s ease;

  &:hover {
    border-color: var(--accent);
    background: rgba(255, 122, 26, 0.08);
  }

  &--dragging {
    border-color: var(--accent);
    background: rgba(255, 122, 26, 0.12);
  }

  &__input {
    display: none;
  }

  &__icon {
    color: var(--accent);
    margin-bottom: 12px;
  }

  &__title {
    font-size: 15px;
    font-weight: 500;
    color: var(--text);
    margin-bottom: 4px;
  }

  &__hint {
    font-size: 12px;
    color: var(--text-dim);
  }
}
</style>
